import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Tell the inline blank-screen self-heal in index.html that React mounted OK —
// clears the heal counter so future stale-SW recovery starts fresh.
if (typeof window.__sv_mounted === "function") {
  // Defer slightly so React has actually committed to the DOM before we
  // declare victory; otherwise StrictMode's double-effect can race.
  setTimeout(window.__sv_mounted, 100);
}

// Register PWA service worker — needed for the install prompt to be eligible.
// We register on any HTTPS host that isn't localhost (covers both production
// and the Emergent preview URL). Dev hot-reload on localhost stays untouched.
if ("serviceWorker" in navigator) {
  const isLocalhost = ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);
  if (!isLocalhost && window.location.protocol === "https:") {
    window.addEventListener("load", () => {
      // `updateViaCache: 'none'` forces Chrome to bypass HTTP cache when
      // fetching /sw.js — without this, browsers may serve the SW from cache
      // for up to 24 h, leaving installed PWAs stranded on old code long after
      // a deploy. With this flag every PWA launch checks for an updated SW.
      navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).catch(() => {});
    });
  }
}
